import styled from "styled-components";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import * as Button from "../../../../../../../../common-deprecated/styles/v2/lexus/components/Button";

export const Wrapper = styled.div<{ center?: boolean }>`
    display: none;
    flex-wrap: wrap;
    align-items: center;
    justify-content: ${({ center }) => (center ? "center" : "space-between")};
    padding: ${theme.space[4]}px 0;
    border-top: 1px solid ${theme.colors.silver};

    ${Button.ButtonWithIcon} {
        margin-right: 0 !important;
    }

    ${Button.ButtonPrimary}, ${Button.ViewMore} {
        margin-top: ${theme.space[3]}px;
        &:not(:last-child) {
            margin-right: ${theme.space[3]}px;
        }

        @media ${getBreakpoint("up", "lg")} {
            margin-top: 0;
        }
    }

    /* on mobile, the step navigation component & mobile footer are always visible and contain the same buttons  */
    @media ${getBreakpoint("up", "lg")} {
        display: flex;
    }

    html[dir="rtl"] & {
        ${Button.ButtonWithIcon} {
            margin-left: 0 !important;
        }
        ${Button.ButtonPrimary}, ${Button.ViewMore} {
            &:not(:last-child) {
                margin-left: ${theme.space[3]}px;
                margin-right: 0;
            }
        }
    }
`;
